import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Clothes } from 'src/app/models/Clothes';
import { DataClothes } from 'src/app/models/DataClothes';
import { Family } from 'src/app/models/Family';
import { NocSizes } from 'src/app/models/NocSizes';
import { UseConditions } from 'src/app/models/UseConditions';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ClothesService } from 'src/app/services/clothes.service';
import { FamilyService } from 'src/app/services/family.service';
import { FileService } from 'src/app/services/file.service';
import { RouteService } from 'src/app/services/routeService';
import { CONSTANTES, getToken } from 'src/app/shared/global';
import * as XLSX from 'xlsx';

declare var jQuery: any;


@Component({
  selector: 'app-clothes-management',
  templateUrl: './clothes-management.component.html',
  styleUrls: ['./clothes-management.component.scss']
})
export class ClothesManagementComponent implements OnInit {

  @ViewChild('images') myFileInput: ElementRef;
  @ViewChild('selectSex') mySex: ElementRef;
  @ViewChild('nocModal') nocModal: ModalDirective;
  @ViewChild('codModal') codModal: ModalDirective;
  
  public nocsData: any[] = [];
  public internalCodeData: any[] = [];
  public clothes: Clothes[];
  public families: Family[];
  public dataFamilies: Family[];
  public subFamilies: Family[];
  public item: Clothes = new Clothes;
  public familySelect: string;
  public subFamilySelect: string;
  public sizesRb: string;
  public priceInput: number;
  public sizesKeys: string[] = ["SÍ", "NO"];
  public clothCode: string = '';
  public maleSizesInput: string;
  public femaleSizesInput: string;
  public unisexSizesInput: string;
  public file: File;
  public numberImages: number;
  public sizes: any[] = [];
  public sexItemAntiguo: string;
  public disabled: any;
  public imagesUrl: string = CONSTANTES.imagesUrl;
  public user: string;
  
  public descriptionSelected: string = '';
  public compositionSelected: string = '';
  public useSelected: string = '';
  public addedUses: UseConditions[] = [];
  public allUsesList: UseConditions[] = [];
  public clothSelected: Clothes = undefined
  public newUseCondition: boolean = false;
  public newUseToSave: string = '';
  public detailModal: boolean = false;


  constructor(private toastr: ToastrService, private spinnerService: NgxSpinnerService, private clothesService: ClothesService,
    private authService: AuthenticationService, private router: Router, private familyService: FamilyService, private routeService: RouteService,
    private fileService: FileService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.spinnerService.show();
    this.user = localStorage.getItem("nid");
    try {
      jQuery.getScript(CONSTANTES.menu);
    } catch (Error) {
      localStorage.removeItem("item");
      this.router.navigate(['login']);
    }
    if(this.route.params){
      this.route.paramMap.subscribe(params => {
      this.clothCode = params.get('code'); 
      }); 
    }
    
    
    this.loadClothes()

  }

  loadClothes() {
    this.clothesService.getVisibleAndInvisibleClothesWithoutData().subscribe(
      data => {
        if (getToken(data)) {
          this.clothes = data.clothes;
          // Ordenamos la lista por nombre
          this.clothes.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            } else if (a.name > b.name) {
              return 1;
            } else {
              return 0;
            }
          });
          this.loadFamilies();
        }
        this.spinnerService.hide();
      }, error => {
        this.toastr.error(error);
        this.logOut();
      }
    );
  }

  loadFamilies() {
    this.familyService.getAll().subscribe(
      data => {
        if (getToken(data)) {
          this.dataFamilies = data.families;
          this.families = [];
          this.subFamilies = [];
          data.families.forEach(element => {
            if (element.parent === null) {
              this.families.push(element);
            } /*else {
              this.subFamilies.push(element);
            }*/
          });
          // Ordenamos la lista por nombre
          this.families.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            } else if (a.name > b.name) {
              return 1;
            } else {
              return 0;
            }
          });
          /*this.subFamilies.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            } else if (a.name > b.name) {
              return 1;
            } else {
              return 0;
            }
          });*/
          this.tokenItem()
        }
        this.spinnerService.hide();
      }, error => {
        this.toastr.error(error);
        this.logOut();
      }
    )
  }

  tokenItem() {
    if (this.routeService.getPreviousUrl().startsWith( "/noc-sizes")) {
      if (localStorage.getItem("item") != null && localStorage.getItem("item") != undefined) {
        this.item = JSON.parse(localStorage.getItem("item"));
        if(this.clothCode == '' || this.clothCode == null)
          this.clothCode = this.item.code
        this.getItem();
      }
    }
  }

  loadSubFamilies() {
    this.subFamilies = [];
    this.dataFamilies.forEach(element => {
      if (element.parent !== null && element.parent.name === this.familySelect) {
        this.subFamilies.push(element);
      }
    });
    this.subFamilies.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      } else if (a.name > b.name) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  async getItem() {
    this.spinnerService.show()
    let element:Clothes = await this.clothesService.getClothByCode(this.clothCode).toPromise();
  
    if (element.prices !== undefined && element.prices !== null && element.prices.length > 0) {
      this.priceInput = element.prices[element.prices.length - 1].price;
    }

    this.familySelect = element.family.parent.name;
    this.loadSubFamilies();
    this.subFamilySelect = element.family.name;
    this.sexItemAntiguo = element.sex;

    if (element.nocSizes !== undefined && element.nocSizes !== null && element.nocSizes.length > 0) {
      this.sizesRb = "SÍ";
      this.maleSizesInput = "";
      this.femaleSizesInput = "";
      this.unisexSizesInput = "";
      element.nocSizes.forEach(nocSize => {
        if (nocSize.sex === "MALE") {
          this.maleSizesInput = this.maleSizesInput.concat(nocSize.size + ",");
        } else if (nocSize.sex === "FEMALE") {
          this.femaleSizesInput = this.femaleSizesInput.concat(nocSize.size + ",");
        } else {
          this.unisexSizesInput = this.unisexSizesInput.concat(nocSize.size + ",");
        }
      });
      // Eliminamos la última coma
      if (this.maleSizesInput !== undefined && this.maleSizesInput !== null && this.maleSizesInput.length > 0) {
        this.maleSizesInput = this.maleSizesInput.substring(0, this.maleSizesInput.length - 1);
      }
      if (this.femaleSizesInput !== undefined && this.femaleSizesInput !== null && this.femaleSizesInput.length > 0) {
        this.femaleSizesInput = this.femaleSizesInput.substring(0, this.femaleSizesInput.length - 1);
      }
      if (this.unisexSizesInput !== undefined && this.unisexSizesInput !== null && this.unisexSizesInput.length > 0) {
        this.unisexSizesInput = this.unisexSizesInput.substring(0, this.unisexSizesInput.length - 1);
      }
    } else {
      this.sizesRb = "NO";
    }
    this.myFileInput.nativeElement.value = "";

    this.numberImages = 0;

    if (element.pictures !== undefined && element.pictures !== null && element.pictures.length > 0) {
      element.pictures.forEach(picture => {
        if (picture.deleted === false) {
          this.numberImages += 1;
        }
      });

    }
    this.spinnerService.hide()
    document.getElementById("divForm").hidden = false;
    this.item = element;
    localStorage.setItem('item', JSON.stringify(this.item));
  }

  clearForm() {
    this.item = new Clothes;
    this.clothCode = '';
    this.priceInput = null;
    this.subFamilySelect = null;
    this.familySelect = null;
    this.sizesRb = null;
    this.maleSizesInput = null;
    this.femaleSizesInput = null;
    this.unisexSizesInput = null;
    this.myFileInput.nativeElement.value = "";
    this.numberImages = null;
    document.getElementById("divForm").hidden = false;
  }

  insertImage() {
    if (this.item.pictures === undefined) {
      this.item.pictures = [];
    }
    this.file = (<HTMLInputElement>document.getElementById("images")).files[0];
    if (this.file !== undefined && this.file !== null && this.file.type === "image/png") {
      let reader = new FileReader();
      let item = this.item;
      let pictureDate = new Date;
      reader.readAsDataURL(this.file);
      reader.onload = function () {
        item.pictures.push({
          picture: reader.result.toString(),
          pictureDate: pictureDate,
          deleted: false,
          fileName: item.code + pictureDate.getTime() + ".png"
        });
      }

    } else {
      this.toastr.warning("LA IMAGEN SELECCIONADA NO TIENE EL FORMATO CORRECTO (.png)");
    }
    this.file = null;
    (<HTMLInputElement>document.getElementById("images")).files = null;
    (<HTMLInputElement>document.getElementById("images")).value = null;
  }

  deleteImage(index: number) {
    this.item.pictures[index].deleted = true;
  }

  submit() {
    this.spinnerService.show();

    // Insertamos el código
    this.item.code = this.clothCode;

    // Si el artículo no tiene precio, se le añade el introducido
    if (this.item.prices === undefined) {
      this.item.prices = [];
      this.item.prices.push({
        price: this.priceInput,
        priceDate: new Date,
      });
    } else if (this.item.prices.length === 0
      || (this.item.prices.length > 0 && this.item.prices[this.item.prices.length - 1].price != this.priceInput)) { // Si el precio introducido es distinto al último precio del artículo, se almacena
      this.item.prices.push({
        price: this.priceInput,
        priceDate: new Date,
      });
    }

    // Se añade la familia al artículo
    if (this.subFamilySelect !== undefined && this.subFamilySelect !== null) { // Si se ha seleccionado subfamilia, se añade
      this.subFamilies.forEach(element => {
        if (element.name === this.subFamilySelect && element.parent.name === this.familySelect) {
          return this.item.family = element;
        }
      });

    }

    // Si se han introducido tallas se insertan en el artículo
    if (this.sizesRb === "SÍ") {
      this.gestionTallas();
    }

    else {
      this.item.nocSizes = [];
    }

    this.clothesService.saveClothes(this.item).subscribe(
      data => {
        if (getToken(data)) {
          if (this.sizes.length > 0) {
            if (data.clothes[0].nocSizes.length < this.item.nocSizes.length) {
              this.toastr.success("SE HA BORRADO UNA TALLA CORRECTAMENTE");
            }
          }
          this.toastr.info("ARTÍCULO GUARDADO CORRECTAMENTE");
          this.clearForm();
          this.loadClothesNotInit();
        } else {
          if (data.errorCode.code === "E_DATA_ERROR") {
            this.toastr.warning(data.errorCode.message);
          } else {
            this.toastr.error(data.errorCode.message);
          }
        }
        this.spinnerService.hide();
      }, error => {
        this.toastr.error(error);
        this.logOut();
      }
    );
    this.spinnerService.hide();
  }


  gestionTallas() {

    let sizesMale: string[] = [];
    let sizesFemale: string[] = [];
    let sizesUnisex: string[] = [];
    let sizesFinal: NocSizes[] = [];
    let sizesFinalFiltrada: NocSizes[] = [];

    if (this.item.nocSizes === undefined || this.item.nocSizes === null) {
      this.item.nocSizes = [];
    } else {
      // Creamos un array con las tallas que tiene el artículo actualmente para no duplicarlas
      this.sizes = [];
      this.item.nocSizes.forEach(element => {
        this.sizes.push(element.size);
      });
    }


    //Solo en el caso de unisex
    //Comprobamos que no haya masc  y fem donde deberia haber unisex
    if (this.item.sex === undefined || this.item.sex === null) {
      //Obtenemos los datos
      if (this.maleSizesInput != null && this.femaleSizesInput != null) {
        if (this.maleSizesInput.length > 0 && this.femaleSizesInput.length > 0) {
          if (this.maleSizesInput.includes(",")) {
            sizesMale = this.maleSizesInput.split(",");
          } else {
            sizesMale.push(this.maleSizesInput);
          }
          if (this.femaleSizesInput.includes(",")) {
            sizesFemale = this.femaleSizesInput.split(",");
          } else {
            sizesFemale.push(this.femaleSizesInput);
          }
          //Añade las comunes que deberian ir en unisex y avisa con un mensaje
          sizesMale.forEach(male => {
            if (sizesFemale.includes(male, 0)) {
              sizesUnisex.push(male);
            }
          })
          if (sizesUnisex.length > 0) {
            this.toastr.info("LAS TALLAS COMUNES FEMENINAS Y MASCULINAS SE HAN PASADO A UNISEX");
          }
        }
      }

      //añadir los del input de unisex (no duplicados con los otros)
      if (this.unisexSizesInput != null && this.unisexSizesInput != undefined && this.unisexSizesInput.length > 0) {
        if (this.unisexSizesInput.includes(",")) {
          this.unisexSizesInput.split(",").forEach(aux => {
            if (!sizesUnisex.includes(aux)) {
              sizesUnisex.push(aux)
            }
          })
        } else {
          if (!sizesUnisex.includes(this.unisexSizesInput)) {
            sizesUnisex.push(this.unisexSizesInput)
          }
        }
        
      }

      //Elimina las comunes de fem y masc que se encuentran en unisex
      if (sizesUnisex.length > 0) {
        sizesUnisex.forEach(size => {
          let indexFemale = sizesFemale.indexOf(size)
          let indexMale = sizesMale.indexOf(size)
          if (indexFemale != -1) {
            sizesFemale.splice(indexFemale, 1);
          }
          if (indexMale != -1) {
            sizesMale.splice(indexMale, 1);
          }
        })
      }
    }

    //CARGAR DATOS DE FEM
    if (this.item.sex === "FEMALE" || (this.femaleSizesInput != null && this.femaleSizesInput != undefined && this.femaleSizesInput.length > 0 && sizesFemale.length == 0)) {
      if (this.femaleSizesInput.includes(",")) {
        sizesFemale = this.femaleSizesInput.split(",");
        
      } else {
        sizesFemale.push(this.femaleSizesInput);
      }
    }

    //CARGAR DATOS DE MASC
    if (this.item.sex === "MALE" || (this.maleSizesInput != null && this.maleSizesInput != undefined && this.maleSizesInput.length > 0 && sizesMale.length == 0)) {
      if (this.maleSizesInput.includes(",")) {
        sizesMale = this.maleSizesInput.split(",");
       
      } else {
        sizesMale.push(this.maleSizesInput);
      }
    }

    //CARGA FEM AL NOC
    if (sizesFemale.length > 0) {
      sizesFemale.forEach(element => {
          sizesFinal.push({
            id: null,
            noc: null,
            internalCode: null,
            npc: null,
            size: element.trim(),
            stock: null,
            sex: "FEMALE",
            threshold: null,
            maxAmount: null,
            generalStaff: null,
            job: null,
            ribbon: null,
            weapon: null
          });
      })
    }

    //CARGA MASC AL NOC
    if (sizesMale.length > 0) {
      sizesMale.forEach(element => {
          sizesFinal.push({
            id: null,
            noc: null,
            internalCode: null,
            npc: null,
            size: element.trim(),
            stock: null,
            sex: "MALE",
            threshold: null,
            maxAmount: null,
            generalStaff: null,
            job: null,
            ribbon: null,
            weapon: null
          });
      })
    }

    //CARGA UNISEX AL NOC
    if (sizesUnisex.length > 0) {
      sizesUnisex.forEach(element => {
          sizesFinal.push({
            id: null,
            noc: null,
            internalCode: null,
            npc: null,
            size: element.trim(),
            stock: null,
            sex: null,
            threshold: null,
            maxAmount: null,
            generalStaff: null,
            job: null,
            ribbon: null,
            weapon: null
          });
      })
    }

    sizesFinal.forEach(talla => {
      let lete = false;
      this.item.nocSizes.forEach(noc => {
        if(noc.size === talla.size) {
          lete = true;
          sizesFinalFiltrada.push(noc);
        }
      })
      if(!lete) {
        sizesFinalFiltrada.push(talla);
      }
    })

    this.item.nocSizes = sizesFinalFiltrada;
  }


  loadClothesNotInit() {
    this.clothesService.getClothesWithoutData().subscribe(
      data => {
        if (getToken(data)) {
          this.clothes = data.clothes;
          // Ordenamos la lista por nombre
          this.clothes.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            } else if (a.name > b.name) {
              return 1;
            } else {
              return 0;
            }
          });

        }
        this.spinnerService.hide();
      }, error => {
        this.toastr.error(error);
        this.logOut();
      }
    );
  }

  vaciar() {
    let result = true;
    if (this.item.sex == "MALE") {
      if (this.item.nocSizes!= undefined) {
        this.item.nocSizes.forEach(tallas => {
          if (tallas.noc != null || tallas.npc != null || tallas.stock != null) {
            result = false;
            
          }
        })
      }
      if (result) {
        this.femaleSizesInput = "";
        this.unisexSizesInput = "";
        this.sexItemAntiguo = this.item.sex;
      }
      else {
        this.toastr.error("NO SE PUEDE MODIFICAR EL SEXO DEL ARTICULO. \n DEBIDO A LA EXISTENCIA DE STOCK O NOC");
        this.item.sex = this.sexItemAntiguo;
        this.mySex.nativeElement.value = this.item.sex;
      }
    }
    else if (this.item.sex == "FEMALE") {
      if (this.item.nocSizes != undefined) {
        this.item.nocSizes.forEach(tallas => {
          if (tallas.noc != null || tallas.npc != null || tallas.stock != null) {
            result = false;

          }
        })
      }
      if (result) {
        this.maleSizesInput = "";
        this.unisexSizesInput = "";
        this.sexItemAntiguo = this.item.sex;
      }
      else {
        this.toastr.error("NO SE PUEDE MODIFICAR EL SEXO DEL ARTICULO. \n DEBIDO A LA EXISTENCIA DE STOCK O NOC");
        this.item.sex = this.sexItemAntiguo;
        this.mySex.nativeElement.value = this.item.sex;
      }
    }

    else {
      if (this.item.nocSizes!= undefined) {
        this.item.nocSizes.forEach(tallas => {
          if (tallas.noc != null || tallas.npc != null || tallas.stock != null) {
            result = false;

          }
        })
      }
      if (result) {
        this.femaleSizesInput = "";
        this.maleSizesInput = "";
        this.item.sex = null;
        this.sexItemAntiguo = this.item.sex;
      }
      else {
        this.toastr.error("NO SE PUEDE MODIFICAR EL SEXO DEL ARTICULO. \n DEBIDO A LA EXISTENCIA DE STOCK O NOC");
        this.item.sex = this.sexItemAntiguo;
        this.mySex.nativeElement.value = this.item.sex;
      }

    }
  }

    onFileChange(event: any, fileType: string): void {
      const target = event.target as HTMLInputElement;
  
      if (target.files && target.files.length) {
        const file = target.files[0];
        const reader = new FileReader();
  
        reader.onload = (e: any) => {
          const bstr: string = e.target.result;
          const workbook: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
  
          if (fileType === 'nocs') {
            this.nocsData = jsonData;
          } else if (fileType === 'internalCode') {
            this.internalCodeData = jsonData;
          }
        };
  
        reader.readAsBinaryString(file);
      } else {
        if (fileType === 'nocs') {
          this.nocsData = [];
        } else if (fileType === 'internalCode') {
          this.internalCodeData = [];
        }
      }
    }
  
    sendDataToBackend(fileType: string): void {
      this.spinnerService.show();
      const data = fileType === 'nocs' ? this.nocsData : this.internalCodeData;
  
      if (data.length > 0) {
        const allowedExtensions = ['xlsx', 'xls'];
        const fileInput = document.getElementById(fileType === 'nocs' ? 'nocsFile' : 'internalCodeFile') as HTMLInputElement;

        if (fileInput && fileInput.files.length) {
          const file = fileInput.files[0];
          const fileExtension = file.name.split('.').pop().toLowerCase();

          if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
            this.toastr.warning('SELECCIONE UN ARCHIVO CORRECTO (xlsx or xls).');
            return;
          }
        } else {
          this.toastr.warning('SIN ARCHIVO SELECCIONADO');
          return;
        }

        if(fileType === 'nocs'){
          this.fileService.updateNocs(data, this.user).subscribe(
            data => {
              if (getToken(data)) {
                this.toastr.success("PRENDAS ACTUALIZADAS");
              }
              if (data.errorFileBase64) {
                this.downloadTxtFile(data.errorFileBase64, 'erroresNocs.txt');
              }
              this.spinnerService.hide();
            }, error => {
              this.toastr.error(error);
              this.logOut();
            }
          );
        }else{
          this.fileService.updateInternalCodes(data, this.user).subscribe(
            data => {
              if (getToken(data)) {
                this.toastr.success("PRENDAS ACTUALIZADAS");
              }
              if (data.errorFileBase64) {
                this.downloadTxtFile(data.errorFileBase64, 'erroresCodigosInternos.txt');
              }
              this.spinnerService.hide();
            }, error => {
              this.toastr.error(error);
              this.logOut();
            }
          );
        }
      }else{
        this.toastr.warning("SIN ARCHIVO SELECCIONADO");
        this.spinnerService.hide();
      }
    }

    downloadTxtFile(base64Content: string, fileName: string): void {
      const decodedContent = atob(base64Content);
      const blob = new Blob([decodedContent], { type: 'text/plain' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    }

    /**
     * Obtiene las condiciones de uso que hay y las del articulo seleccionado
     */
    loadUseConditions(){
      this.getAllUsesConditions();
      this.addedUses = []
      this.clothSelected = JSON.parse(JSON.stringify(this.item));
      //let clothData = await this.clothesService.getUseConditionsByCloth(this.clothSelected).toPromise();
      if(this.clothSelected.useConditions != null && this.clothSelected.useConditions.length != 0)
        this.addedUses = this.clothSelected.useConditions
    }

    async getAllUsesConditions(){
      this.allUsesList = []
      let data = await this.clothesService.getAllUsesConditions().toPromise();
      if(getToken(data)){
        if(data.useConditions != null && data.useConditions.length != 0)
          this.allUsesList = data.useConditions;
      }
    }

    /**
     * Agrega una nueva condicion de uso a la bbdd
     */
    saveNewUseCondition(){
      this.spinnerService.show();
      if(this.newUseToSave != ''){
        let newUse = new UseConditions();
        newUse.description = this.newUseToSave;
        newUse.disabled = false;
        this.clothesService.saveNewUseCondition(newUse).subscribe(
          data=>{
            if(getToken(data)){
              if(data.useConditions != null && data.useConditions.length != 0){
                data.useConditions.forEach(u=> this.allUsesList.push(u))
              }
              this.spinnerService.hide();
              this.newUseCondition = false
              this.toastr.success("CONDICION DE USO GUARDADA");
            } else{
              this.toastr.error("ERROR AL AÑADIR NUEVA CONDICION DE USO");
              this.newUseToSave = '';
              this.spinnerService.hide();
            }
          },error => {
            this.toastr.error(error);
            this.spinnerService.hide();
          }
        )
      } else
        this.toastr.info("INTRODUZCA CONDICION DE USO");
      this.spinnerService.hide();
      this.newUseToSave = ''
    }

    /**
     * Añade una condicion de uso al articulo seleccionado
     */
    addUseCondition(){
      let result = false
      let uses: UseConditions = undefined
      this.addedUses.forEach(au=>{
        if(au.description == this.useSelected)
          result= true;
      })

      if(!result){
        uses = this.allUsesList.find(u=> u.description == this.useSelected);
        if(uses != undefined && uses != null)
          this.addedUses.push(uses)
      } else
        this.toastr.info("CONDICION DE USO YA EXISTENTE")
      this.useSelected = undefined
    }

    /**
     * Elimina una condicion de uso al articulo seleccionado
     */
    deleteUseCondition(index: number){
      this.addedUses.splice(index, 1);
    }

    /**
     * Guarda las condiciones de uso para el articulo seleccionado
     */
    updateUseConditions(){
      let dataClothes: DataClothes = new DataClothes();
      this.spinnerService.show();
      this.item.composition = this.clothSelected.composition;
      this.item.description = this.clothSelected.description;
      this.item.useConditions = this.addedUses;
      dataClothes.clothes = [this.item];
      this.clothesService.updateItemUseCondition(dataClothes).subscribe(
        data=>{
          if(getToken(data)){
            if(data.clothes[0].useConditions != null && data.clothes[0].useConditions. length != 0){
              this.item.useConditions = data.clothes[0].useConditions;
              this.item.composition = data.clothes[0].composition;
              this.item.description = data.clothes[0].description;
              this.spinnerService.hide();
              this.toastr.info("CONDICIONES DE USO ACTUALIZADAS")
            }
          } else{
            this.spinnerService.hide();
            this.toastr.error(data.errorCode.message);
          }
            
        }, error => {
          this.toastr.error(error);
          this.logOut();
        }
      )
      this.detailModal = !this.detailModal
      
    }

    specifications(){
      this.loadUseConditions();
      this.detailModal = true;
    }
    
    closeModal(){
      this.detailModal = !this.detailModal
    }

    


    openModalNoc(){
      this.nocModal.show();
    }

    openModalCod(){
      this.codModal.show();
    }
}
